import React, { Component } from 'react'
import {
  Form, Input, DatePicker, Button, Upload, Icon, Modal
} from 'antd'
import styled from "styled-components"
import { withTranslation } from 'react-i18next';

const { RangePicker } = DatePicker

const Tips = styled.div`
  line-height:2.5em;
  color:#f81d22;
`;

const MyUpload=styled(Upload)`
  .ant-upload-list-item{
    margin-top:24px;
    height:auto;
    background-color:#F8FAFB;
    padding:14px;
    cursor:pointer;
    color:#2FC29B;
    .ant-upload-list-item-name{
      text-decoration:underline;
    }
    .ant-upload-list-item-info{
      background-color:inherit !important;
    }
  }
  .ant-upload-list-item-info .anticon-paper-clip,
  .ant-upload-list-item .anticon-close{
    margin-top:14px;
    margin-right:14px;
  }
`

const TemplateLink = styled(Button)`
  margin-right:20px;
`;

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogShow:false,
      fileList:[]
    };
  }
  initDialog=()=>{
    this.setState({dialogShow:true})
  }
  handleCancel=()=>{
    this.setState({
      dialogShow:false,
      fileList:[]
    })
  }
  handleOk=()=>{
    this.setState({dialogShow:false})
    this.props.search()
  }
  render() {
    const {t,filterChange,search, download}=this.props
    const {fileList,dialogShow}=this.state
    const props = {
      name: 'file',
      accept:'.xls,.xlsx,.csv',
      beforeUpload:(file)=>{
        this.setState(
          {fileList:[file]},
          ()=>{
            filterChange('file',this.state.fileList[0])
          }
        )
        return false
      },
      onPreview(file){
        var aLink=document.createElement('a')
        var blob=new Blob([file])
        aLink.download=file.name
        aLink.href=URL.createObjectURL(blob)
        aLink.click()
      },
      onRemove:()=>{
        this.setState({fileList:[]})
        filterChange('file',null)
      }
    }
    return (
      <div>
        <Form layout="inline">
            <Form.Item label={t('Date')}>
              <RangePicker allowClear onChange={(value)=>{filterChange('time',value)}}></RangePicker>
            </Form.Item>
          <Form.Item label={t('IMEI')}>
            <Input allowClear onChange={(e)=>{filterChange('imei',e.target.value)}}></Input>
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={this.initDialog}>
              <Icon type="upload"></Icon>
              {t('Import IMEI')}
            </Button>
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={() => {download()}}>
              <Icon type="download"></Icon>
              {t('Export')}
            </Button>
          </Form.Item>
          <Form.Item>
            <Button onClick={()=>{
              this.setState({fileList:[]})
              search(true)
            }}>{t('Search')}</Button>
          </Form.Item>
        </Form>
        <Tips>{t('Note: The search results will be cleared after you quit or refresh the page.')}</Tips>
        <Modal title={t('Import IMEI')} visible={dialogShow} onOk={this.handleOk} onCancel={this.handleCancel} okText={t('Search')}>
          <MyUpload {...props} fileList={fileList}>
           <div style={{marginBottom:'10px'}}>
           <TemplateLink href={'/api/downloadTpl?type=0'} onClick={(e)=>{e.stopPropagation()}}>{t('Download Template(.xls)')}</TemplateLink>
           <TemplateLink href={'/api/downloadTpl?type=2'} onClick={(e)=>{e.stopPropagation()}}>{t('Download Template(.csv)')}</TemplateLink>
           </div>
            <Button type="primary">
              <Icon type="upload"></Icon>
              {t('Import IMEI')}
            </Button>
          </MyUpload>
        </Modal>
      </div>
    )
  }
}

export default withTranslation()(Filter);